import React, { useContext } from 'react'
import { useEffect, useState } from 'react'
import $ from 'jquery'
import getDomainName from 'helpers/getDomainName'
import settings from 'Services/settings'
import { MainContext } from 'components/Main/provider'
import { get } from 'lodash'
import { history } from 'helpers/history'
import useFetchData from 'hooks/fetch-data'

const ArcFlashReadiness = () => {
  const [embedUrl, setEmbedUrl] = useState()
  const siteId = sessionStorage.getItem('siteId')
  const selectedSiteId = localStorage.getItem('selectedSiteId')
  const [parameter, setParameter] = useState({
    userSessionId: localStorage.getItem('userLoginSessionId'),
    siteId: selectedSiteId != null && selectedSiteId != undefined ? selectedSiteId : siteId !== null ? siteId : localStorage.getItem('siteId'),
    accessToken: localStorage.getItem('accessToken'),
    domain: getDomainName(),
  })

  const { featureFlag, setFeatureFlag } = useContext(MainContext)

  const createQueryString = params => {
    return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
  }

  const handleFlagFormatter = res => {
    const flagKeys = ['estimator', 'allowed_to_update_formio', 'is_required_maintenance_command_center', 'is_reactflow_required', 'is_facility_overview_required', 'is_required_retool_workorder_reporting', 'is_required_arc_flash_readiness', 'is_reactflow_in_workorder_required']
    const featureFlags = get(res, 'data.list', [])
      .filter(d => flagKeys.includes(d.featureName.trim()))
      .reduce((acc, curr) => {
        acc[curr.featureName.trim()] = curr.isRequired
        return acc
      }, {})

    setFeatureFlag({
      isEgalvanicAI: false,
      isUpdateFormIO: featureFlags.allowed_to_update_formio || false,
      isEstimator: featureFlags.estimator || false,
      isRequiredMaintenanceCommandCenter: featureFlags.is_required_maintenance_command_center || false,
      isReactFlowSingleLine: featureFlags.is_reactflow_required || false,
      isFacilityOverviewRequired: featureFlags.is_facility_overview_required || false,
      isRequiredRetoolWorkorderReporting: featureFlags.is_required_retool_workorder_reporting || false,
      isRequiredArcFlashReadiness: featureFlags.is_required_arc_flash_readiness || false,
      isReactflowInWorkorderRequired: featureFlags.is_reactflow_in_workorder_required || false,
      isAssetHealthRequired: featureFlags.is_asset_health_required || false,
    })
    if (!featureFlags.is_required_arc_flash_readiness ?? !featureFlag.isRequiredArcFlashReadiness) {
      history.push(process.env.PUBLIC_URL + '/assets')
    }
  }

  useFetchData({ fetch: settings.featuresFlagByCompany, formatter: d => handleFlagFormatter(d) })

  useEffect(() => {
    $('#pageLoading').show()
    ;(async () => {
      try {
        const addQueryParam = `https://egalvanic.retool.com/embedded/public/d79cdecd-0d46-4e59-be9d-009cad65f9b2?${createQueryString(parameter)}`
        setEmbedUrl(addQueryParam)
        $('#pageLoading').hide()
      } catch (error) {
        $('#pageLoading').hide()
        console.log(error)
      }
    })()
  }, [])

  return <iframe src={embedUrl} title='description' style={{ height: 'calc(100vh - 70px)', width: '100%' }}></iframe>
}

export default ArcFlashReadiness
